















import Vue from 'vue'
import { mapGetters } from 'vuex'
import { ADD_TOAST_MESSAGE } from 'vuex-toast'
import get from 'lodash.get'
import Icon from '@/components/Icon/Icon.vue'
import HintCard, { HintItem } from '@/components/HintCard/HintCard.vue'
import { KnowledgeAction } from '@/store/modules/knowledge/actions'
import { KnowledgeBlock } from '@/models/knowledge'

interface Data {
  isSaveInProgress: boolean
  saveErrorMessage: string | false
}

interface Methods {
  handleToggleBlock: () => void
  handleUpdateBlock: (item: HintItem) => Promise<void>
  handleDeleteBlock: (item: HintItem) => void
  handleValidateBlock: () => void
}

interface Computed {
  isCollapsed: boolean
  openBlockIds: string[]
}

interface Props {
  isReadonly: boolean
  block: KnowledgeBlock
  sectionId: string
  baseId?: string
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    Icon,
    HintCard,
  },
  props: {
    isReadonly: {
      default: () => false,
    },
    block: {
      required: true,
    },
    sectionId: {
      required: false,
    },
    baseId: {
      required: false,
    },
  },
  data() {
    return {
      isSaveInProgress: false,
      saveErrorMessage: false,
    }
  },
  computed: {
    ...mapGetters({
      openBlockIds: 'getOpenBlockIds',
    }),
    isCollapsed() {
      return !this.openBlockIds.includes(this.block.id)
    },
  },
  methods: {
    handleToggleBlock() {
      this.$store.dispatch(KnowledgeAction.ToggleBlock, this.block.id)
    },
    async handleUpdateBlock(item: HintItem) {
      if (this.baseId) {
        try {
          this.isSaveInProgress = true
          await this.$store.dispatch(KnowledgeAction.UpdateBlock, {
            baseId: this.baseId,
            sectionId: this.sectionId,
            blockId: item.id,
            title: item.title,
            snippet: item.snippet,
            content: item.content,
          })
          this.isSaveInProgress = false
        } catch (e) {
          this.saveErrorMessage = get(
            e,
            'message',
            this.$tc('common.saveFailed'),
          )
          this.isSaveInProgress = false
        }
      }
    },
    handleDeleteBlock(item: HintItem) {
      this.$useConfirmDialog(
        [
          this.$tc('common.areYouSure'),
          {
            type: 'danger',
            okText: this.$tc('common.remove'),
            cancelText: this.$tc('common.cancel'),
          },
        ],
        () => {
          this.$store.dispatch(KnowledgeAction.DeleteBlock, {
            baseId: this.baseId,
            sectionId: this.sectionId,
            blockId: item.id,
          })
        },
        !!this.baseId,
      )
    },
    handleValidateBlock() {
      this.$store.dispatch(ADD_TOAST_MESSAGE, {
        text: this.$tc('errors.maxTextLength'),
        type: 'warning',
      })
    },
  },
})
